import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-registro',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './registro.component.html',
  styleUrl: './registro.component.css',
  standalone: true
})
export class RegistroComponent {
form: FormGroup;
  loading = false;
  error = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.form = this.fb.group({
      nombre: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      telefono: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]]
    });
  }

  registrar() {
    if (this.form.invalid) return;

    this.loading = true;
    this.error = '';

    this.authService.registrar(this.form.value).subscribe({
      next: () => {
        alert('Usuario creado correctamente');
        this.router.navigate(['/login']);
      },
      error: () => {
        this.error = 'Error al crear usuario';
        this.loading = false;
      }
    });
  }
  volverLogin() {
    this.router.navigate(['/login']);
  }
}
